//import { RouteComponentProps } from 'react-router';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Link, RouteComponentProps, Redirect } from 'react-router-dom';

import { Grid } from 'react-bootstrap';
import * as TF from '../../service/tradeflow';
import * as DTO from '../../service/DTOs';
import * as Session from '../../service/Session';
import * as Dispatch from '../../service/Dispatcher';
import * as RB from 'react-bootstrap';
import { Disclaimer1 } from '../../components/shared/Disclaimer1';


type LoginProps = Session.LoginState & { xsrfToken?: string } & RouteComponentProps<{}>;

const initialstate: Session.LoginState = {
    cred: { userName: '', password: '', islockedout: false },
    loggedin: false    
}

//export class Login extends React.Component<LoginProps, Session.LoginState> {
export class Login extends React.Component<RouteComponentProps<{}>, Session.LoginState> {
    
    //constructor(props: LoginProps | undefined) {
    constructor(props: RouteComponentProps<{}>) {
        super(props);
        this.state = {
            ...initialstate
            //, loggedin: this.props.loggedin
        };
    }

    handleChange(e: React.ChangeEvent<any>) { // should be HTMLInputElement
            var _cred = { ...this.state.cred, ...{ [e.target.name]: e.target.value } };
            this.setState({ cred: _cred });
    }

    private login(event: React.FormEvent<RB.Form>) {
        this._login(this.state.cred);
        event.preventDefault();
    }

    getValidationState(): "success" | "warning" | "error" | null {
        return null;
    }

    getState = () => {
        return this.state;
    }

    dispatch = (action: Session.LoginAction) => {
        return Dispatch.LoginDispatcher(this, action);
    }


    _login = (loginInput: Session.Credentials) => {
        return Session.accountActions.login(loginInput, this.getState, this.dispatch);
    }

    queryParam(name: string, location: string): string | null {
        var results = new RegExp(`[\?&]${name}=([^&#]*)`).exec(location);
        if (results == null) {
            return null;
        }
        else {
            return decodeURIComponent(results[1]) || null;
        }
    }

    renderLoggedIn() {
        var redirect: string;
        // const query = new URLSearchParams(this.props.location.search);
        const returnUrl = this.queryParam('returnUrl', this.props.location.search);
        const isAbsolute = new RegExp('^([a-z]+://|//)', 'i');
        if (returnUrl && !isAbsolute.test(returnUrl)) {
            redirect = returnUrl;
        } else {
            redirect = "/app";
        }

        if (redirect === this.props.history.location.pathname)
            return null;

        return (<Grid>
            <Redirect to={redirect} />
        </Grid>);
    }

    renderAnonymous() {
        //{head()}
        //validationState = { this.getValidationState() }

        return <div>
            <Grid className="rep_login">

                <h3 className="rep_authTitle">Вход или <Link to={'/register'}>Регистрация</Link></h3>
                <h4 className="rep_authTitle rep_dimmedText">OTC REPO SYSTEM</h4>
                <RB.Row>
                    <RB.Col xs={12} sm={6} smOffset={3} >
                        <RB.Form className="rep_loginForm" onSubmit={(e) => this.login(e)} autoComplete="off">
                            <RB.FormGroup validationState={this.state.loginError ? "error" : null}>
                                <RB.InputGroup>
                                    <RB.InputGroup.Addon><i className="fa fa-user" /></RB.InputGroup.Addon>
                                    <RB.FormControl name="userName" type="text" onChange={(e) => this.handleChange(e)} placeholder="User Name" />
                                </RB.InputGroup>
                                {/*<RB.FormControl.Feedback />*/}
                                <RB.HelpBlock>{this.state.loginError}</RB.HelpBlock>
                        </RB.FormGroup>

                        <RB.FormGroup validationState={this.state.loginError ? "error" : null}>
                            <RB.InputGroup>
                                <RB.InputGroup.Addon><i className="fa fa-lock" /></RB.InputGroup.Addon>
                                <RB.FormControl name="password" type="password" onChange={(e) => this.handleChange(e)} placeholder="Password" />
                            </RB.InputGroup>
                            <RB.HelpBlock>{this.state.loginError}</RB.HelpBlock>
                        </RB.FormGroup>

                        <RB.Button className="btn btn-primary btn-block btn btn-default" type="submit">Login</RB.Button>
                    </RB.Form>
                </RB.Col>
            </RB.Row>
            </Grid>
            <Grid style={{ maxWidth: '100%' }}>
                <RB.Row>
                    <RB.Col xs={12} sm={10} smOffset={1} >
                        <RB.Row>
                            <Disclaimer1 {...this.props} />
                        </RB.Row>
                    </RB.Col>
                </RB.Row>

            </Grid>
        </div>
    }

    public render() {
        if (this.state.loggedin)
            return this.renderLoggedIn();
        else
            return this.renderAnonymous();
    }
}


